import React from 'react';
import {
  FormBuilder_Ui_Alignment,
  type FormBuilder_ScreenNode,
  type FormBuilder_ScreenNode_Block,
  type FormBuilder_ScreenNode_Block_FormData_Ui_Image_Fragment,
  type FormData_Ui_Image,
} from '~/graphql/types';
import BlockLayout from '../BlockLayout';
import LocalesInput from '../LocalesInput';
import Input from '~/components/molecule/Input';
import BlockAlignment from '../BlockAlignment';
import ImageOrAssetUploadComponent from '~/components/molecule/ImageOrAssetUploadComponent';
import { useRecoilValue } from 'recoil';
import { initialFormAtom } from '~/components/page/Forms/components/Builder/state';

export type Props = {
  onChange: (block: FormBuilder_ScreenNode_Block) => void;
  block: FormData_Ui_Image;
  nodeId: string;
};

const Image: React.FCC<Props> = ({ onChange, nodeId, block }) => {
  const initialFormValue = useRecoilValue(initialFormAtom);
  const savedNode = initialFormValue?.nodes.find(
    node => node.id === nodeId,
  ) as FormBuilder_ScreenNode;
  const savedBlock = savedNode?.blocks.find(
    ({ key }) => key === block.key,
  ) as FormBuilder_ScreenNode_Block_FormData_Ui_Image_Fragment;

  return (
    <BlockLayout blockKey={block.key} nodeId={nodeId}>
      <ImageOrAssetUploadComponent
        imageFileName="screen_node_image_block"
        currentImage={block.image}
        initialImage={savedBlock?.image}
        containerDirection="column"
        onParentUpdate={args => {
          if (!args) return;
          onChange({
            ...block,
            image: args,
          });
        }}
      />
      <LocalesInput
        label={{ NL: 'Terugvaltekst', EN: 'Terugvaltekst' }}
        block={block}
        onChange={onChange}
        subject="alt"
        blockKey={block.key}
        nodeId={nodeId}
      />
      <BlockAlignment
        alignment={block.alignment ?? FormBuilder_Ui_Alignment.Left}
        onChange={alignment => {
          onChange({
            ...block,
            alignment,
          });
        }}
      />
      <Input
        label={{ text: 'Breedte (px)' }}
        width="100%"
        onChange={event => {
          const parsed = parseInt(event.target.value);
          onChange({
            ...block,
            width: isNaN(parsed) ? 0 : parsed,
          });
        }}
        value={block.width ?? 0}
      />
    </BlockLayout>
  );
};

export default Image;
